module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "names"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("NAMES AND RELATIONSHIPS")]), _vm._v(" "), _c('p', {
    staticClass: "names"
  }, [_vm._v("ABDOUL AZIZ GÉER: second oldest son of Sokna and Demba")]), _vm._v(" "), _c('p', {
    staticClass: "names"
  }, [_vm._v("AMINATA (Ami): friend of Ramatoulaye")]), _vm._v(" "), _c('p', {
    staticClass: "names"
  }, [_vm._v("BINTU: daughter fostered to Géer family")]), _vm._v(" "), _c('p', {
    staticClass: "names"
  }, [_vm._v("CHEIKH CAAYA: husband of Cora")]), _vm._v(" "), _c('p', {
    staticClass: "names"
  }, [_vm._v("CORA: friend of Sokna")]), _vm._v(" "), _c('p', {
    staticClass: "names"
  }, [_vm._v("DEMBA GÉER: husband of Sokna Géer")]), _vm._v(" "), _c('p', {
    staticClass: "names"
  }, [_vm._v("JIGEEN GÉER: oldest daughter of Sokna and Demba")]), _vm._v(" "), _c('p', {
    staticClass: "names"
  }, [_vm._v("MODOU BAXA: father of Penda’s child")]), _vm._v(" "), _c('p', {
    staticClass: "names"
  }, [_vm._v("MUSA MBACKE: Murid trader and suitor of Bintu")]), _vm._v(" "), _c('p', {
    staticClass: "names"
  }, [_vm._v("PENDA: daughter of Cora")]), _vm._v(" "), _c('p', {
    staticClass: "names"
  }, [_vm._v("RAMATOULAYE (Rama)GÉER: second oldest daughter of Sokna and Demba")]), _vm._v(" "), _c('p', {
    staticClass: "names"
  }, [_vm._v("SOKNA GÉER: wife of Demba Géer")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32d4ba2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/names_and_relationships.vue
// module id = 78
// module chunks = 0